import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
 
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  useEffect(()=>{
    const token = localStorage.getItem("Rikosta");
    if(token){
      setIsAuthenticated(true)
    }else{
      setIsAuthenticated(false)
    }
  },[])
  
  return isAuthenticated && isAuthenticated ==true? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
